// EN lang

export default {
    username: 'Username',
    password: 'Password',
    repeat_password: 'Repeat password',
    login: 'Log in',
    copyright: 'Copyright',
    update: 'Update',
    create: 'Create',
    submit: 'Submit',
    delete: 'Delete',
    optional: 'Optional',
    color: 'Color',
    icon: 'Icon',
    description: 'Description',
    title: 'Title',
    author: 'Author',
    page: 'Page',
    pages: 'Pages',
    new_page: 'New page',
    new: 'New',
    pronunciation: 'Pronunciation',
    order: 'Order',
    letter: 'Letter',
    name: 'Name',
    email_or_username: 'Email or username',
    forms: {
        correct_form_errors : 'Please correct the following errors'
    },
    validation: {
        required: "Field {attribute} is required",
        email: "Field {attribute} is not a proper email address",
        minLength: "Field {attribute} does not meet the minimum characters",
        sameAsPassword: "Passwords must be identical."
    },
    expired_session: 'Your session has expired, please log in again',
    login_required: 'Login required',
    login_section: {
        init_msg: "Enter your email or username/password to access the site.",
        forgot_your_password: "Forgot your password?",
        dont_have_an_account: "Don't have an account?",
        sign_up: "Sign Up"
    },
    datatable: {
        recordsperpage: 'Records per page',
        filter: 'Filter',
        typetosearch: 'Type to Search',
        clear: 'Clear',
        loading: 'Loading',
        showing: 'Showing',
        of: 'of',
        totalrows: 'total rows'
    },
    company_info_section: {
        company_name: 'Company name',
        phone_number: 'Phone number',
        primary_color: 'Primary color',
        whatsapp_number: 'Whatsapp number',
        contact_email: 'Contact email',
        support_email: 'Support email',
        instagram_name: 'Instagram name',
        instagram_url: 'Instagram URL',
        facebook_name: 'Facebook name',
        facebook_url: 'Facebook URL'
    },
    calendar: {
        days: {
            Mon: 'Lun',
            Tue: 'Mar',
            Wed: 'Mié',
            Thu: 'Jue',
            Fri: 'Vie',
            Sat: 'Sáb',
            Sun: 'Dom',
            Monday: 'Lunes',
            Tuesday: 'Martes',
            Wednesday: 'Miércoles',
            Thursday: 'Jueves',
            Friday: 'Viernes',
            Saturday: 'Sábado',
            Sunday: 'Domingo'
        },
        months: {
            January: 'Enero',
            February: 'Febrero',
            March: 'Marzo',
            April: 'Abril',
            May: 'Mayo',
            June: 'Junio',
            July: 'Julio',
            August: 'Agosto',
            September: 'Septiembre',
            October: 'Octubre',
            November: 'Noviembre',
            December: 'Diciembre'
        }
    }
}